module.exports = __webpack_public_path__ + "static/media/0_2019_04_28.1dd0e244.jpg";